var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Document icon/other") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5441176,20 L1.45588235,20 C0.651821029,20 0,19.3603896 0,18.5714286 L0,1.42857143 C0,0.639593506 0.651821029,0 1.45588235,0 L11.25,0 L18,6.62337662 L18,18.5714286 C18,19.3603896 17.3481618,20 16.5441176,20 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u270F\\uFE0F-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-176.000000, -1670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-icon/other",
    transform: "translate(176.333333, 1670.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5441176,20 L1.45588235,20 C0.651821029,20 0,19.3603896 0,18.5714286 L0,1.42857143 C0,0.639593506 0.651821029,0 1.45588235,0 L11.25,0 L18,6.62337662 L18,18.5714286 C18,19.3603896 17.3481618,20 16.5441176,20 Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,6.62337662 L12.7058824,6.62337662 C11.9018382,6.62337662 11.25,5.98378571 11.25,5.19480519 L11.25,0 L18,6.62337662 Z",
    fill: "#D9D9D9"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.9fef45bc5edc01731de9137689e3042b.svg";
export { ForwardRef as ReactComponent };